module.exports = __webpack_public_path__ + "media/customizations/carolinaorchards/logo-new-e92f876fddc7b22873d281523ee76937.png";